import { LoadingState } from "../domain/data-layer/loading-state";
import { SwarovskiPageData, SwarovskiPageDataFrontend } from "@swo/storefront";

import { useCallback, useEffect, useRef, useState } from "react";
import { useOnRouteChangeOnce } from "../hooks/use-on-route-change";
import { pageViewEvent, pushableEventOfPure } from "../domain/google-tag-manager/pushable";
import { Location } from "react-router";

export function usePageViewTracking(dataLs: { data: LoadingState<SwarovskiPageDataFrontend>; dataKey: string }) {
  const lastLocation = useRef<Location | null>(null);
  const [forceRefreshKey, forceRefresh] = useRefresh();

  useEffect(() => {
    if (dataLs.data.__tag === "loaded") {
      const {
        data: { segment, locale, page },
      } = dataLs.data;

      if (lastLocation.current && lastLocation.current.pathname === dataLs.dataKey) {
        const event = pushableEventOfPure(
          pageViewEvent({
            locale,
            segment,
            page,
          }),
        );

        window.setTimeout(() => {
          void event.push();
        }, /* Delay it slightly so that Page Metadata is updated and correctly collected by GTM. Delay is completely arbitrary. */ 50);
      }
    }
  }, [JSON.stringify(dataLs), forceRefreshKey]);

  useOnRouteChangeOnce(location => {
    const previous = lastLocation.current;

    lastLocation.current = location;

    // This is a way to trigger pageview when url changes
    if (previous && previous.pathname === location.pathname && previous.search !== location.search) {
      forceRefresh();
    }
  });
}

function useRefresh() {
  const [state, setState] = useState<number>(0);

  const refreshTrigger = useCallback(() => {
    setState(Math.random());
  }, []);

  return [state, refreshTrigger] as const;
}
